// Module
var code = "<li> <a ng-click=\"raiseEvent()\"><i class=\"{{subitem.icon}}\"></i>{{subitem.name}}</a> </li> ";
// Exports
export default code;